import * as React from 'react';
import type { SVGProps } from 'react';
import { memo } from 'react';
export const SvgSquareCheckDimension = {
  height: 24,
  width: 24,
  viewBox: '0 0 24 24',
};
export const SvgSquareCheck = memo((props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} fill="none" {...props}>
    <path
      fill="currentColor"
      d="M17 3a4 4 0 0 1 4 4v10a4 4 0 0 1-4 4H7a4 4 0 0 1-4-4V7a4 4 0 0 1 4-4zm.962 4.371a.89.89 0 0 0-1.257 0L10 14.076l-2.704-2.705a.89.89 0 0 0-1.258 1.258l3.334 3.333a.89.89 0 0 0 1.257 0l7.333-7.333a.89.89 0 0 0 0-1.258"
    />
  </svg>
));
